import React from "react"

import { BLOCKS } from "./richTextConstants"

export const withFinePrint = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (node, children) => {
      // Extract raw text from node content to detect fine print markers
      const rawText = node.content
        ?.map((item) => item.value || "")
        .join("")
        .trim()

      if (
        rawText &&
        (rawText.indexOf("<sub>") === 0 || rawText.indexOf("<sup>") === 0) &&
        (rawText.indexOf("</sub>") !== -1 || rawText.indexOf("</sup>") !== -1)
      ) {
        const strippedText = rawText
          .replace(/<\/sub>/g, "")
          .replace(/<\/sup>/g, "")
          .replace(/<sub>/g, "")
          .replace(/<sup>/g, "")

        return <p className="finePrint">{strippedText}</p>
      } else {
        return <p>{children}</p>
      }
    },
    [BLOCKS.TABLE]: (node, next) => {
      return `<table><tbody>${next(node.content)}</tbody></table>`
    },
    [BLOCKS.TABLE_CELL]: (node, next) => {
      return `<td>${next(node.content)}</td>`
    },
    [BLOCKS.TABLE_HEADER_CELL]: (node, next) => {
      return `<th>${next(node.content)}</th>`
    },
    [BLOCKS.TABLE_ROW]: (node, next) => {
      return `<tr>${next(node.content)}</tr>`
    },
  },
}

export const withEmbeddedAsset = {
  renderNode: {
    // EMBEDDED_ASSET rendering removed - now handled by customRichTextRenderer with proper reference resolution
  },
}

export const withAllOptions = {
  renderNode: {
    // EMBEDDED_ASSET rendering removed - now handled by customRichTextRenderer with proper reference resolution
    [BLOCKS.PARAGRAPH]: (node, children) => {
      // Extract raw text from node content to detect fine print markers
      const rawText = node.content
        ?.map((item) => item.value || "")
        .join("")
        .trim()

      if (
        rawText &&
        (rawText.indexOf("<sub>") === 0 || rawText.indexOf("<sup>") === 0) &&
        (rawText.indexOf("</sub>") !== -1 || rawText.indexOf("</sup>") !== -1)
      ) {
        const strippedText = rawText
          .replace(/<\/sub>/g, "")
          .replace(/<\/sup>/g, "")
          .replace(/<sub>/g, "")
          .replace(/<sup>/g, "")

        return <p className="finePrint">{strippedText}</p>
      } else {
        return <p>{children}</p>
      }
    },
  },
}
